<template>
    <div class="container full">
        <!-- 个人信息、头像+公司+真实姓名 -->
        <Row class-name="home-header">
            <!-- 官网图片 -->
            <Col>
                <a class="main-header-left-logo"></a>
            </Col>
            <!-- 头像 当前公司名称-->
            <Col style="display: flex;width: calc(100% - 200px);justify-content: flex-end;align-items: center;">
                <h4 class="margin-right-10">{{$store.state.user.user?$store.state.user.user.realname:''}}</h4>
                <Avatar  class="user-info-head" @click.native="personalInfoShow=!personalInfoShow" :src="$store.state.user.user?$store.state.user.user.head_url:''"/>
            </Col>
        </Row>
        <!-- 四个方块 分别显示  在线电梯 、故障电梯、离线电梯、全部电梯、 -->
        <div class="device-count">
                <div class="item all-device">
                    <span class="item-title">
                    全部电梯
                    </span>
                    <span>
                        {{index.count}}
                    </span>
                </div>
                <div class="item online-device">
                    <span class="item-title">
                    在线电梯
                    </span>
                    <span>
                         {{index.onlineCount}}
                    </span>
                </div>
                <div class="item offline-device">
                    <span class="item-title">
                    离线电梯
                    </span>
                    <span>
                         {{index.offlineCount}}
                    </span>
                </div>
                <div class="item fault-device">
                     <span class="item-title">
                    故障电梯
                    </span>
                    <span>
                         {{index.faultDeviceCount}}
                    </span>
                </div>
            </div>
        <!-- 搜索、添加 -->
        <div class="search-add">
            <Row slot="extra"  type="flex" justify="end">
                <Col class="margin-right-10" span="10">
                    <Input  class="search-keyword" v-model="table.page.keyword" search
                           :placeholder="$t('l.remark67')" @on-change="searchBlur" @on-search="loadData(1)"/>
                </Col>
                <Col class="margin-right-10">
                    <Button v-if="$ifauth('fun_device_add_like')" ghost type="primary" @click="toggleLikes">
                        {{monitorList.showMonitor?$t('l.back_devices'):$t('l.my_focus')}}
                        <Badge v-if="!monitorList.showMonitor&&!table.loading" :offset="[1,-4]" type="primary"
                               :count="monitorList.likes.length"></Badge>
                    </Button>
                </Col>
                <Col >
                    <res-view key-name="fun_device_add">
                        <Button type="primary" @click="preAdd('modal_device')">{{$t('l.add_device')}}</Button>
                    </res-view>
                </Col>
            </Row>
        </div>
        <!-- 列表页面 -->
        <div class="device-list" ref="deviceList">
            <Scroll :distance-to-edge="10" :height="height" :on-reach-top="handleReachTop" :on-reach-bottom="handleReachBottom">
                <template v-if="table.data.length">
                    <div @click="detail(item)" class="device-item" :style="{borderLeft:item.broken?'5px solid #ff7675':item.online?'5px solid #2ecc71':'5px solid #b2bec3',marginTop:index>0?'10px':'0px'}" v-for="(item,index) in table.data" :key="index">
                        <!-- 类型图标 -->
                        <span class="device-type-icon">
                            <template v-if="item.type === 0||item.type === 3">
                                <img v-if="item.current_status.run_up == 1" src="images/device/lift-icon-up.png"/>
                                <img v-else-if="item.current_status.run_down == 1" src="images/device/lift-icon-down.png"/>
                                <img v-else src="images/device/lift-icon.png"/>
                            </template>
                            <img v-else-if="item.type === 1" src="images/device/door-icon.png"/>
                            <img v-else-if="item.type === 2" src="images/device/ad-icon.png"/>
                    </span>
                        <div class="device-other">
                            <!-- 设备名称 -->
                            <div class="device-name">{{item.name}}</div>
                            <div class="device-preedit" @click.stop="preEdit(item,index)">
                                <span>编辑</span>
                            </div>
                            <template>
                                <!-- 状态 -->
                                <div class="device-status-online">
                                    <!-- 关注列表 批量状态 -->
                                    <template v-if="monitorList.showMonitor">
                                        <div class="margin-right-10 floor-text">{{item.current_status&&item.current_status.floor_current?item.current_status.floor_current:''}}</div>
                                    </template>
                                    <div></div>
                                    <!-- 终端类型 -->
                                    <template v-if="item.terminal_id">
                                        <span v-if="item.terminal_id.startsWith('E')" class="terminal_type">WCR</span>
                                        <span v-else-if="item.terminal_id.startsWith('W')" class="terminal_type">TWCR</span>
                                        <span v-else class="terminal_type">VWCR</span>
                                    </template>

                                    <div :class="item.broken?'device-status-dian-fault':(!item.online)?'device-status-dian':'device-status-dian-online'"></div>
                                    <div class="margin-left-5" :class="item.broken?'device-status-text-fault':!item.online?'device-status-text':'device-status-text-online'">{{item.broken?'故障':!item.online?'离线':'在线'}}</div>
                                </div>
                            </template>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="no-data-image"></div>
                    <div class="no-data-text">暂无数据</div>
                </template>
            </Scroll>
            <Spin fix v-if="table.loading">加载中...</Spin>
        </div>
        <!-- 个人详情信息 -->
        <template>
            <Drawer class-name="drawer-person" :title="$t('l.person_info')"  width="350" :closable="false" v-model="personalInfoShow">
                <login-info></login-info>
            </Drawer>
        </template>
        <!-- 电梯添加 -->
        <template>
            <lg-modal  :title="modal.title" :show="modal.show" :loading="modal.loading" @on-submit="onSubmit('modal')"
                      @on-cancel="modal.loading=false;modal.show = false;">
                <Form :rules="getRules" ref="modal" :model="modal" :label-width="80"
                      style="max-height: 400px; overflow-y: auto;overflow-x: hidden">
                    <FormItem :label="$t('l.device_type')">
                        <RadioGroup type="button" v-model="modal.device.type"
                                    @on-change="changeRadio">
                            <Radio v-for="t in search.type.values" :label="t.id" :key="t.id" v-if="t.isAuth&&t.show">{{t.name}}</Radio>
                        </RadioGroup>
                    </FormItem>
                    <FormItem prop="device.name"  :label="$t('l.elevator_name')">
                        <Input v-model="modal.device.name" :placeholder="$t('l.elevator_name')"/>
                    </FormItem>
                    <FormItem :label="$t('l.community')">
                        <Row :gutter="5">
                            <Col span="20">
                                <Select :placeholder="$t('l.remark71')"
                                        v-model="modal.device.community_id"
                                        filterable
                                        remote
                                        ref="setQuery"
                                        :remote-method="remoteSearchCommunity"
                                        :loading="modal.searchLoading.community_id"
                                        @on-change="onCommunitySelect">
                                    <Option v-for="(comm) in search.community_id.values" :value="comm.id"
                                            :key="comm.id">{{comm.name}}</Option>
                                </Select>
                            </Col>
                            <Col span="2">
                                <Button :title="$t('l.create_community')" @click="preJumpAddCommunity">+</Button>
                            </Col>
                        </Row>
                    </FormItem>
                    <FormItem :label="$t('l.build_unit')">
                        <Cascader v-model="modal.choosedLocationIds"
                                  :data="modal.locationTree"
                                  change-on-select
                                  @on-change="onLocationSelect"
                                  :placeholder="$t('l.remark74')">
                        </Cascader>
                    </FormItem>
                    <FormItem  :label="$t('l.detail_address')">
                        <Input type="textarea" v-model="modal.device.address" :placeholder="$t('l.remark75')" ></Input>
                    </FormItem>
                    <FormItem prop="totalFloor" :label-width="93"
                              :label="$t('l.total_floor') + ' ' + (modal.device.j_floors.negative + modal.device.j_floors.positive)">
                        <input type="hidden" :value="modal.totalFloor" :disabled="modal.device.type==3"/>
                        <!-- 楼层编辑 -->
                        <Row type="flex">
                            <Col span="8" class="floor-edit">
                                <span class="text-font-size margin-right-5">{{$t('l.positive_floor')}}</span>
                                <InputNumber type="number" v-model="modal.device.j_floors.positive"
                                             :disabled="modal.device.type==3" :min="0"
                                             :max="(modal.device.device_param.is_through_door?32:64) - modal.device.j_floors.negative"
                                             @on-change="onTotalFloorChange($event, 1)"/>
                            </Col>
                            <Col class="floor-edit margin-left-10" span="8">
                                <!--<span style="margin: 0 10px">-->
                                <span class="text-font-size margin-right-5">{{$t('l.negative_floor')}}</span>
                                <InputNumber :disabled="modal.device.type==3" type="number"
                                             v-model="modal.device.j_floors.negative" :min="0"
                                             :max="(modal.device.device_param.is_through_door?32:64) - modal.device.j_floors.positive"
                                             @on-change="onTotalFloorChange($event, -1)"/>
                                <!--</span>-->
                            </Col>
                        </Row>
                        <!-- 贯通门 -->
                        <Row>
                            <Col span="10" >
                                <span style="margin: 0 5px 0 0 ">
                                <span class="text-font-size margin-right-5" style="display: inline-flex;align-items: center">{{$t('l.through_door')}}</span>
                                    <i-switch  @on-change="switch_change_through"
                                          :true-value="1"
                                          :false-value="0"
                                          v-model="modal.device.device_param.is_through_door" ref="switch_change_through"
                                          size="small">
                            </i-switch>
                                </span>
                            </Col>
                            <Col span="12" class="floor-edit">
                                <!--<span class="text-font-size margin-right-5">负楼层</span>-->
                                <Poptip transfer :title="$t('l.floor_editor') + (modal.device.device_param.is_through_door?'(' + $t('l.through_door') + ')':'')"
                                        placement="bottom" :transfer="true" ref="floor_editor">
                                    <Button @click="modal.showFloorEditor=true;" icon="md-options">{{$t('l.floor_editor')}}</Button>
                                    <floor-editor :floors="modal.device.j_floors"
                                                  :positive="modal.device.j_floors.positive"
                                                  :negative="modal.device.j_floors.negative"
                                                  :is-through-door="modal.device.device_param.is_through_door"
                                                  slot="content"
                                                  @on-close="$refs.floor_editor.handleClose()"></floor-editor>
                                </Poptip>
                            </Col>
                        </Row>
                    </FormItem>
                    <FormItem v-if="modal.push_way&&modal.push_way.length" :label="$t('l.select_push_city')">
                        <RadioGroup @on-change="chooseRadio" v-model="modal.device.regulatory_field.way">
                            <!--  推送  参数说明 、 获取推送列表请求参数-->
                            <Radio v-for="(elem) in modal.push_way" :label="elem.label" :key="elem.label">
                                <span>{{elem.name}}</span>
                            </Radio>
                        </RadioGroup>
                    </FormItem>
                    <div v-for="(lt,i) in modal.filed_list" :key="i">
                        <FormItem  :label="lt.explain" >
                            <Input :placeholder="$t('l.remark73')+lt.explain" v-model="modal.device.regulatory_field[lt.filed]"/>
                        </FormItem>
                    </div>
                    <FormItem :label="$t('l.lift_type')">
                        <Select :placeholder="$t('l.remark78')" v-model="modal.device.device_param.type">
                            <Option v-for="item in getDeviceTypeList"
                                    :value="item.id"
                                    :key="item.id">{{ item.lable }}
                            </Option>
                        </Select>
                    </FormItem>
                    <FormItem :label="$t('l.lift_id')">
                        <Input v-model="modal.device.code" :placeholder="$t('l.lift_id')"/>
                    </FormItem>
                    <FormItem :label="$t('l.lift_mode')">
                        <Input v-model="modal.device.model" :placeholder="$t('l.lift_mode')"/>
                    </FormItem>
                    <FormItem prop="rated_speed" :label="$t('l.rated_speed')">
                        <Input v-model="modal.device.device_param.rated_speed" :placeholder="$t('l.rated_speed')"/>
                    </FormItem>
                    <FormItem prop="rated_load" :label="$t('l.rated_load')">
                        <Input v-model="modal.device.device_param.rated_load" :placeholder="$t('l.rated_load')"/>
                    </FormItem>
                    <FormItem prop="terminal_id" :label="$t('l.terminal')">
                        <Input v-model="modal.device.terminal_id" :placeholder="$t('l.terminal_id')"/>
                    </FormItem>
                    <FormItem v-if="modal.device.type==0" prop="face_id" :label="$t('l.face')">
                        <Input v-model="modal.device.face_id" :placeholder="$t('l.face_terminal_id')"/>
                    </FormItem>
                    <FormItem prop="factory_cid" :label="$t('l.manufacturer')">
                        <Select :placeholder="$t('l.select_manufacturer2')"
                                v-model="modal.device.factory_cid"
                                filterable
                                remote
                                :remote-method="remoteSearchFactory"
                                :loading="modal.searchLoading.factory"
                                @on-change="remoteSearchFactoryBranch('', 'replace')">
                            <Option v-for="(factory) in search.factory_cid.values" :value="factory.id"
                                    :key="factory.id">{{factory.name}}</Option>
                        </Select>
                    </FormItem>
                    <FormItem :label-width="120" prop="factory_branch" :label="$t('l.manufacturer_branch')" v-if="modal.device.factory_cid>0">
                        <Select :placeholder="$t('l.remark82')"
                                v-model="modal.device.factory_branch"
                                filterable
                                remote
                                :remote-method="remoteSearchFactoryBranch"
                                :loading="modal.searchLoading.factoryBranch">
                            <Option v-for="(factory) in search.factory_branch.values" :value="factory.id"
                                    :key="factory.id">{{factory.name}}</Option>
                        </Select>
                    </FormItem>
                    <FormItem prop="mt_cid" :label="$t('l.mt_company')">
                        <Select :placeholder="$t('l.remark83')"
                                v-model="modal.device.mt_cid"
                                filterable
                                remote
                                :remote-method="remoteSearchMT"
                                :loading="modal.searchLoading.mt">
                            <!--@on-change.stop="remoteSearchMTWorker">-->
                            <Option v-for="(depart) in search.mt_cid.values" :ref="'option'+depart.id"
                                    :value="depart.id" :key="depart.id">{{depart.name}}</Option>
                        </Select>
                    </FormItem>
                    <FormItem  :label="$t('l.mt_person')">
                        <Row :gutter="5">
                            <Col span="20">
                                <Select :placeholder="$t('l.remark84')"
                                        v-model="modal.mt_worker_mbile"
                                        multiple
                                        filterable
                                        :loading="modal.searchLoading.mt_worker">
                                    <Option v-for="(member) in search.j_mt_woker.values" :value="member.mobile"
                                            :key="member.mobile">{{member.name}}({{member.mobile}})</Option>
                                </Select>
                            </Col>
                            <!--<Col span="2">-->
                                <!--<Button :title="$t('l.add_maintenance')" @click="addMtWorkers">+</Button>-->
                            <!--</Col>-->
                        </Row>
                    </FormItem>
                    <FormItem :label="$t('l.principal')">
                        <Row :gutter="5">
                            <Col span="20">
                                <Select :placeholder="$t('l.remark85')"
                                        v-model="modal.fzrs_mobile"
                                        multiple
                                        filterable
                                        :loading="modal.searchLoading.fzrLoading">
                                    <Option v-for="(member) in search.j_fzrs.values" :value="member.mobile"
                                            :key="member.mobile">{{member.name}}({{member.mobile}})</Option>
                                </Select>
                            </Col>
                            <!--<Col span="2">-->
                                <!--<Button :title="$t('l.add_principal')" @click="addFzrs">+</Button>-->
                            <!--</Col>-->
                        </Row>
                    </FormItem>
                    <FormItem :label="$t('l.ad_company')">
                        <Select  :placeholder="$t('l.remark86')"
                                v-model="modal.device.ad_cid"
                                filterable
                                remote
                                :remote-method="remoteSearchAD"
                                :loading="modal.searchLoading.ad">
                            <Option v-for="(depart) in search.ad_cid.values" :value="depart.id" :key="depart.id">
                                {{depart.name}}
                            </Option>
                        </Select>
                    </FormItem>
                    <FormItem :label-width="82"  prop="alarm_charger_mobile" :label="$t('l.alarm_mobile')">
                        <Row :gutter="5">
                            <Col span="20">
                                <Select :placeholder="$t('l.remark87')"
                                        v-model="modal.alarm_charger_mobile"
                                        multiple
                                        filterable
                                        clearable
                                        @on-clear="modal.alarm_charger_mobile = []; modal.device.j_alarm_charger = null;"
                                        :loading="modal.searchLoading.alarm_charger">
                                    <Option v-for="(member) in search.j_alarm_charger.values" :value="member.mobile"
                                            :key="member.mobile">{{member.name}}({{member.mobile}})
                                    </Option>
                                </Select>
                            </Col>
                            <!--<Col span="2">-->
                                <!--<Button :title="$t('l.add_alarm_mobile')" @click="addAlarmCharger">+</Button>-->
                            <!--</Col>-->
                        </Row>
                    </FormItem>
                </Form>
            </lg-modal>
        </template>
    </div>
</template>

<script>
    import util from '@/libs/util.js';
    import LoginInfo from "../main-components/login-info";
    import extraConfig from "../../constant-data/extra-config";
    import resView from  "../my-components/res-view";
    import LgModal from "../my-components/lg-modal";
    import FloorEditor from "../device/component/floor-editor";
    import ws from '@/libs/websocket';
    import monitorUtil from '../device/modules/list-monitor';

    let roleTypes = {
        ROOT: 1,
        AMDIN: 2,
        PROXY: 3,
        ELEV_FACTORY: 4,
        MT_COMPANY: 5,
        WY_COMPANY: 6,
        GOV: 7,
        AD: 8,
        CONSUMER:10
    }
    export default {
        name: "m_home",
        components:{LoginInfo,resView,LgModal,FloorEditor},
        data(){
            return{
                validateTotalFloor : (rule, value, callback) => {
                    if (value <= 0 || value > 64) {
                        callback(new Error(this.$t('l.remark89')));
                    } else if (!value) {
                        callback(new Error(this.$t('l.remark33')));
                    } else {
                        callback();
                    }
                },
                table:{
                    loadTime:0,
                    loading:true,
                    data:[],
                    page: {
                        current: 1,  // 当前页码
                        size: 10, // 每页个数
                        sizeOptions: [12, 18, 24, 48, 60],
                        total: 0,
                        sortKey: 'online',
                        sortMethod: 'desc',
                        keyword: ''
                    },
                    min_id:0
                },
                index:{
                    count:0,
                    faultDeviceCount:0,
                    offlineCount:0,
                    onlineCount:0
                },
                personalInfoShow:false,
                modal: {
                    current_radio:0,
                    show: false,
                    showFace: false,
                    // currentDeviceIsHost: false,
                    showFloorEditor: false,
                    title: this.$t('l.add_device'),
                    loading: false,
                    switch: false, // 贯通门选
                    // distantUpdate: false,//楼层别名远程同步至android端
                    currentIndex: -1,
                    totalFloor: 0,
                    current_selected_terminal:'',// 当前选择的终端
                    searchLoading: {
                        community_id: false,
                        factory: false,
                        factoryBranch: false,
                        mt: false,
                        ad: false,
                        mt_worker: false,
                        alarm_charger: false,
                        real_devices: false,
                        regionLoading:false,
                        fzrLoading:false
                    },
                    alarm_charger_mobile: [],
                    fzrs_mobile:[],
                    mt_worker_mbile:[],
                    // regionList:[], // 搜索城市列表
                    filed_list:[], //  地方监管接口必填字段列表
                    push_way:[],  // 地方监管接口推送 方式
                    locationTree: [],
                    choosedLocationIds: [],
                    device: {
                        code:'',
                        model:'',
                        device_param: {
                            rated_speed: "",
                            rated_load: "",
                            type: 0,
                            is_through_door: 0
                        },
                        longitude:0,
                        latitude:0,
                        vm_device_id: "",
                        type: 0,
                        name: '',
                        qr_id: 0,
                        j_floors: {
                            display: [],
                            unstop: [],
                            negative: 0, // 负楼层
                            positive: 0     //正楼层
                        },
                        j_param: {},
                        community_id: 0,
                        terminal_id: null,
                        terminal_id_curve: null, // 曲线终端
                        face_id: null,
                        j_location: {},
                        factory_cid: 0,
                        factory_branch: 0,
                        mt_cid: 0,
                        j_mt_workers: [],
                        j_fzes:[], // 电梯负责人
                        ad_cid: 0,
                        j_alarm_charger: null,
                        j_extra_capacity: [],
                        regulatory_field:{way:''},
                        city_id:0,
                        address:''
                    },
                    // confirmHostDeviceId:0, // 确定主电梯 id
                    extra_capacity_list: extraConfig,
                },
                search: {
                    type: {
                        label: this.$t('l.device_type'),
                        values: [
                            {id: 0, name: this.$t('l.lift'),isAuth:true,show:true},
                            // {id: 1, name: '门禁'},
                            // {id: 2, name: '广告机'},
                            // {id: 3, name: this.$t('l.virtual_lift'),show:true,isAuth:this.$ifauth('fun_vm_device')}
                        ],
                        selected: []
                    },
                    device_state: {
                        label: this.$t('l.device_type'),
                        values: [
                            {id: 0, name: this.$t('l.online')},
                            {id: 1, name: this.$t('l.offline')},
                            {id: 2, name: this.$t('l.fault')},
                        ],
                        selected: [],
                    },
                    new_old: {
                        label: this.$t('l.terminal_type'),
                        values: [
                            {id: 0, name: 'WCR'},
                            {id: 1, name: this.$t('l.smart_screen')},
                        ],
                        selected: [],
                    },
                    community_id: {
                        label: this.$t('l.community'),
                        values: [],
                        selected: [],
                        handler: this.onCommunityChoosed.bind(this)
                    },
                    building_id: {
                        label: this.$t('l.build_unit'),
                        values: [],
                        selected: []
                    },
                    factory_cid: {
                        label: this.$t('l.manufacturer'),
                        values: [],
                        selected: []
                    },
                    factory_branch: {
                        label: this.$t('l.manufacturer_branch'),
                        values: [],
                        selected: []
                    },
                    mt_cid: {
                        label: this.$t('l.mt_company'),
                        values: [],
                        selected: []
                    },
                    j_mt_woker: {
                        label: this.$t('l.mt_person'),
                        disabled: true,
                        values: [],
                        selected: []
                    },
                    j_fzrs: {
                        label: this.$t('l.principal'),
                        disabled: true,
                        values: [],
                        selected: []
                    },
                    ad_cid: {
                        label: this.$t('l.ad_company'),
                        values: [],
                        selected: []
                    },
                    j_alarm_charger: {
                        label: this.$t('l.alarm_mobile'),
                        values: [],
                        selected: []
                    }
                },
                height:0,
                monitorList: {
                    showMonitor: false,
                    likes: [],
                },
            }
        },
        methods:{
            searchBlur() {
                if (!this.table.page.keyword) this.loadData(1);
            },
            toggleLikes() {
                if (this.monitorList.likes.length > 0) {  // 真正的选择关注的设备才能发请求
                    this.monitorList.showMonitor = !this.monitorList.showMonitor;
                    this.loadData(this.table.page.current);
                    if (!this.monitorList.showMonitor) monitorUtil.destroy(); // 返回列表页
                } else {  //  没有关注的设备
                    if (!this.monitorList.showMonitor) {
                        this.$Message.warning(this.$t('l.remark95'));
                        return;
                    }
                    this.monitorList.showMonitor = false;
                    this.loadData(this.table.page.current, this.search);
                    // if (!this.monitorList.showMonitor) monitorUtil.destroy();
                }
            },
            loadLikes() {
                util.ajax.get('/device/getlikes').then(res => {
                    this.monitorList.likes.push(...res.data);
                })
            },
            preAdd(name) {
                let d = this.modal.device = {
                    type: 0,
                    name: '',
                    j_floors: {
                        display: [],
                        unstop: [],
                        negative: 0,
                        positive: 0
                    },
                    longitude:0,
                    latitude:0,
                    j_param: {},
                    community_id: 0,
                    vm_device_id:'',
                    qr_id: 0,
                    terminal_id: '',
                    terminal_id_curve:'',
                    j_location: {},
                    factory_cid: 0,
                    factory_branch: 0,
                    mt_cid: 0,
                    j_mt_workers: [],
                    j_fzrs: [],
                    ad_cid: 0,
                    j_alarm_charger: null,
                    device_param: {
                        rated_speed: "",
                        rated_load: "",
                        type: 0,
                        is_through_door: 0,
                    },
                    regulatory_field:{},
                    city_id:0,
                    address:''
                }
                this.modal.alarm_charger_mobile = [];
                this.modal.fzrs_mobile = [];
                this.modal.mt_worker_mbile = []
                this.modal.totalFloor = 0;
                let myCompany = this.$store.state.user.user.company;
                switch (myCompany.role_id) {
                    case roleTypes.ELEV_FACTORY:
                        d.factory_cid = myCompany.id;
                        break;
                    case roleTypes.MT_COMPANY:
                        d.mt_cid = myCompany.id;
                        this.remoteSearchMTWorker(myCompany.id);
                        break;
                    case roleTypes.AD:
                        d.ad_cid = myCompany.id;
                        break;
                }
                this.modal.filed_list=[]
                if (this.modal.push_way&&this.modal.push_way.length) {
                    this.modal.device.regulatory_field.way = this.modal.push_way[0].label;
                    this.modal.filed_list = this.modal.push_way[0].j_config;
                }
                this.modal.choosedLocationIds=[]
                this.modal.show = true;
            },
            preEdit(device, index) {
                this.onCommunitySelect(device.community_id);
                this.$refs.setQuery.setQuery(device.community_name)
                this.modal.currentIndex = index;
                this.modal.totalFloor = device.j_floors.display.length;
                device.j_extra_capacity = device.j_extra_capacity?device.j_extra_capacity:[];
                // this.search.type.values[1].show = false;
                if (!device.regulatory_field) device.regulatory_field={way:''};
                else device.regulatory_field = typeof device.regulatory_field == 'string'?JSON.parse(device.regulatory_field):device.regulatory_field;
                this.modal.device = this.copyCurrentDevice(device);   // 报错
                this.changeRegulatoryField();
                this.remoteSearchFactoryBranch("","replace");
                let j_location = util.parseJSON(this.modal.device.j_location, {});
                let choosedLocationIds = [];
                if (j_location.building) choosedLocationIds.push(j_location.building.id);
                if (j_location.unit) choosedLocationIds.push(j_location.unit.id);
                if (j_location.door) choosedLocationIds.push(j_location.door.id);
                setTimeout(() => {
                    this.modal.choosedLocationIds = choosedLocationIds;
                }, 100)
                this.modal.alarm_charger_mobile = [];
                this.modal.fzrs_mobile = [];
                this.modal.mt_worker_mbile = [];

                if (device.j_alarm_charger) {
                    device.j_alarm_charger.forEach(charger => this.modal.alarm_charger_mobile.push(charger.mobile))
                }
                if (device.j_fzrs) {
                    device.j_fzrs.forEach(fzr => this.modal.fzrs_mobile.push(fzr.mobile))
                }
                if (device.j_mt_workers) {
                    device.j_mt_workers.forEach(mt => this.modal.mt_worker_mbile.push(mt.mobile))
                }
                this.modal.title = this.$t('l.device_info');
                this.modal.show = true;
            },
            changeRegulatoryField(){
                if (this.modal.push_way.length){
                    let a = this.modal.push_way.find(e=>{
                        return e.label === this.modal.device.regulatory_field.way;
                    })
                    if (a){
                        this.modal.filed_list = a.j_config;
                    }
                }
            },
            copyCurrentDevice(device){
                let device_new = {
                    id:0,
                    device_param: {
                        rated_speed: "",
                        rated_load: "",
                        type: 0,
                        is_through_door: 0
                    },
                    vm_device_id: '',
                    type: 0,
                    // liftType: 0,
                    name: '',
                    qr_id: 0,
                    j_floors: {
                        display: [],
                        unstop: [],
                        negative: 0, // 负楼层
                        positive: 0     //正楼层
                    },
                    j_param: {},
                    community_id: 0,
                    terminal_id: null,
                    face_id: null,
                    j_location: {},
                    factory_cid: 0,
                    factory_branch: 0,
                    mt_cid: 0,
                    j_mt_workers: [],
                    ad_cid: 0,
                    j_alarm_charger: null,
                    j_extra_capacity: [],
                    regulatory_field:{},
                    city_id:0
                }
                Object.keys(device).forEach(key=>{
                    device_new[key]=device[key];
                })
                return device_new;
            },
            loadData(page = 1) {
                let now = Date.now();
                if (now - this.table.loadTime < 1000) return;
                this.table.loadTime = now;
                this.table.loading = true;
                if (page==1||this.table.page.keyword) {
                    this.table.min_id = 0;
                    this.table.data=[];
                }
                if (this.monitorList.showMonitor){// 关注列表
                    util.ajax.get('/device/listlike').then(res => {
                        this.table.data=[];
                        this.setPage({list: res.data})
                        monitorUtil.refreshList(res.data);
                        monitorUtil.ws.on('up_report_status', this.onMonitorMessage.bind(this), 1);
                        // return res.data.map(device => device.id);
                        this.table.loading = false;
                    }).then((idArr) => {
                        // 通过电梯运行状态 设置
                        // util.ajax.get('/fault/listbydevice', {
                        //     params: {ids: idArr.join(',')}
                        // }).then(res1 => {
                        //     this.setDeviceFaults(res1.data);
                        // })
                    })
                    return;
                } else{

                    util.ajax.post("/device/mdevicelist?type=['all']&min_id="+this.table.min_id+'&keyword='+this.table.page.keyword).then(res => {
                        this.table.loading = false;
                        if(!res.code && res.data) {
                            this.setPage(res.data);
                            let ids = res.data.list.map(device => device.id);
                            this.table.min_id=ids&&ids.length?ids[ids.length-1]:0;
                            return ids;
                        }else{
                            return [];
                        }
                    }).then((idArr) => {
                        if (idArr&&idArr.length){
                            util.ajax.get('/fault/listbydevice', {
                                params: {
                                    ids: idArr.join(','),
                                }
                            }).then(res1 => {
                                this.setDeviceFaults(res1.data);
                            })
                        }
                    })
                }
            }
            ,
            onMonitorMessage(message) {
                let deviceName = message.deviceName;
                let statusContent = message.data;
                let device = this.deviceMap[deviceName];
                if (!device) return;
                // 设置楼层对应
                Object.keys(statusContent).forEach(field => {
                    if ((field == "CAN_fault"||field=="run_fault")&&statusContent[field]==1) {
                        this.$set(device, 'broken', true);
                    } else if (field == "floor_current"&&device.j_floors.display){
                        this.$set(device.current_status, "floor_current", device.j_floors.display[statusContent[field]]);
                    }else{
                        this.$set(device.current_status, field, statusContent[field]);
                    }
                })

                this.table.data.forEach(de => {
                    if (de.id ==device.id&&device.broken) {
                        this.$set(de, 'broken', true);
                    }else{
                        this.$set(de, 'broken', false);
                    }
                })
                // this.setDeviceFaults();
            },
            loadIndexData(){
                util.ajax.get("/indexdata").then(res => {
                    if (res&&!res.code) {
                        this.index.count = res.data.count?res.data.count:0;
                        this.index.faultDeviceCount = res.data.faultDeviceCount?res.data.faultDeviceCount:0;
                        this.index.offlineCount = res.data.offlineCount?res.data.offlineCount:0;
                        this.index.onlineCount = res.data.onlineCount?res.data.onlineCount:0;
                    }
                })
            },
            setPage(pageInfo) {
                if (pageInfo) {
                    let ids = [];
                    pageInfo.list.forEach(device => {
                        ids.push(device.id);
                        util.parseJSONResult(device);
                        if (device) {
                            device.device_param = util.parseJSON(device.device_param);
                            this.$set(device, 'online', device.online);
                            this.$set(device, 'current_status', {});
                        }
                        this.table.data.push(device);
                    })
                    if (!pageInfo.hasMore) this.$Message.warning("没有更多数据了")
                }
            }
            ,
            setDeviceFaults(faults) {
                let faultMap = {};
                if (faults) {
                    faults.forEach(fault => {
                        faultMap[fault.device_id] = true;
                    })
                }
                this.table.data.forEach(device => {
                    if (faultMap[device.id]) {
                        this.$set(device, 'broken', true);
                    }
                })
            }
            ,
            onAdd(){
                this.$Message.success("成功");
            }
            ,
            detail(device){
                this.$router.push(
                    {
                        name: 'm_monitor',
                        params: {
                            device, id: device.id,
                            page: this.pageNum,
                            terminal_id: device.terminal_id ? device.terminal_id : device.vm_device_id,
                            terminal_id_curve:device.terminal_id_curve,
                            online: device.online,
                            status: device.online ? 'online' : 'offline'
                        }
                    })
            },
            handleReachTop(){
                this.loadData(1);
            },
            handleReachBottom(){
               this.loadData(2);
            },
            changeRadio(){
                this.$refs['modal'].resetFields();
            },
            onCommunityChoosed(isAdd, index) {
                if (isAdd && this.search.community_id.selected.length === 1) {
                    let comm = this.search.community_id.values[index];
                    comm.j_buildings = util.parseJSON(comm.j_buildings, []);
                    this.search.building_id.values = comm.j_buildings;
                } else {
                    this.search.building_id.values = [];
                }
                this.search.building_id.selected = [];
            },
            remoteSearchCommunity(value) {
                if (!value.trim()) return;
                this.modal.searchLoading.community_id = true;
                util.ajax.get('/device/searchoption', {
                    params: {
                        table: 't_community',
                        field: 'name',
                        value: '%' + value + '%'
                    }
                }).then(res => {
                    this.modal.searchLoading.community_id = false;
                    let existed = this.search.community_id.values.map(item => item.id)
                    res.data.forEach(comm => {
                        if (!existed.includes(comm.id)) {
                            this.search.community_id.values.push(comm)
                        }
                    })
                    // this.modal.choosedLocationIds=[]
                    // if (community){
                    //     this.modal.locationTree = util.parseJSON(community.j_buildings, []);
                    //     this.modal.locationTree.forEach(b => {
                    //         b.value = b.id;
                    //         b.label = b.name;
                    //         b.children = b.units;
                    //         b.units.forEach(u => {
                    //             u.value = u.id;
                    //             u.label = u.name;
                    //             u.children = u.doors;
                    //             u.doors.forEach(d => {
                    //                 d.value = d.id;
                    //                 d.label = d.name;
                    //             })
                    //         })
                    //     })
                    // }
                })
            },
            onCommunitySelect(commId) { // 编辑小区 如果更换小区那么新的绑定地址也得更换
                if (!commId) return;
                let community = this.search.community_id.values.find(comm => {
                    return comm.id === commId;
                })
                this.modal.choosedLocationIds = []
                console.log(community)
                if (community) {
                    if (!this.modal.device.address){ // 绑定小区了，但是没有详细device.address字段 为null
                        if (community.j_region){
                            community.j_region = JSON.parse(community.j_region);
                            this.modal.device.address = community.j_region.province.name+
                                community.j_region.city.name+(community.j_region.area?community.j_region.area.name+(community.address?community.address:''):'')
                        }
                    }
                    this.modal.locationTree = util.parseJSON(community.j_buildings, []);
                    this.modal.locationTree.forEach(b => {
                        b.value = b.id;
                        b.label = b.name;
                        b.children = b.units;
                        b.units.forEach(u => {
                            u.value = u.id;
                            u.label = u.name;
                            u.children = u.doors;
                            u.doors.forEach(d => {
                                d.value = d.id;
                                d.label = d.name;
                            })
                        })
                    })
                }
            },
            preJumpAddCommunity() {
                this.$Modal.confirm({
                    title: this.$t('l.prompt'),
                    content: this.$t('l.remark93'),
                    okText : this.$t('l.confirm'),
                    cancelText : this.$t('l.cancel'),
                    onOk: () => {
                        this.$router.push({name: 'page_community'})
                    }
                })
            },
            onLocationSelect(value, selected) {
                let location = this.modal.device.j_location = {};
                if (selected[0]) location.building = {
                    id: selected[0].id,
                    name: selected[0].name
                };
                if (selected[1]) location.unit = {
                    id: selected[1].id,
                    name: selected[1].name
                };
            },
            switch_change_through(val) {
                if (val) {
                    if (this.modal.totalFloor > 32) {
                        this.$Modal.warning({
                            content: this.$t('l.remark172')
                        })
                        this.$refs.switch_change_through.toggle({
                            preventDefault: () => {
                            }
                        });
                        return;
                    }
                    this.modal.device.device_param.is_through_door = 1;
                    let partA = [];
                    let partB = [];
                    for (let i = 1; i <= this.modal.device.j_floors.negative; i++) {
                        partA.unshift((-i).toString() + 'A');
                        partB.unshift((-i).toString() + 'B');
                    }
                    for (let i = 1; i <= this.modal.device.j_floors.positive; i++) {
                        partA.push(i.toString() + 'A');
                        partB.push(i.toString() + 'B');
                    }
                    this.modal.device.j_floors.display = partA.concat(partB);
                } else {
                    this.modal.device.device_param.is_through_door = 0;
                    this.modal.device.j_floors.display = [];
                    for (let i = 1; i <= this.modal.device.j_floors.negative; i++) {
                        this.modal.device.j_floors.display.unshift((-i).toString());
                    }
                    for (let i = 1; i <= this.modal.device.j_floors.positive; i++) {
                        this.modal.device.j_floors.display.push(i.toString());
                    }
                }
            },
            remoteSearchFactoryBranch(value, action) {
                value = value.trim();
                if (!action&&!value) return;
                if (!this.modal.device.factory_cid) return;
                this.modal.searchLoading.factoryBranch = true;
                util.ajax.get('/device/searchoption', {
                    params: {
                        table: 't_depart',
                        field: 'name',
                        value: '%' + value + '%',
                        other: JSON.stringify({
                            pid: this.modal.device.factory_cid,
                            type: 0,
                            role_id: roleTypes.ELEV_FACTORY
                        })
                    }
                }).then(res => {
                    this.modal.searchLoading.factoryBranch = false;
                    if (action === 'replace') this.search.factory_branch.values = [];
                    let existed = this.search.factory_branch.values.map(item => item.id)
                    res.data.forEach(comm => {
                        if (!existed.includes(comm.id)) {
                            this.search.factory_branch.values.unshift(comm)
                        }
                    })
                })
            },
            remoteSearchFactory(value) {
                if (!value.trim()) return;
                this.modal.searchLoading.member = true;
                util.ajax.get('/device/searchoption', {
                    params: {
                        table: 't_depart',
                        field: 'name',
                        value: '%' + value.trim() + '%',
                        other: JSON.stringify({
                            pid: 0,
                            type: 0,
                            role_id: roleTypes.ELEV_FACTORY
                        })
                    }
                }).then(res => {
                    this.modal.searchLoading.member = false;
                    let existed = this.search.factory_cid.values.map(item => item.id)
                    res.data.forEach(comm => {
                        if (!existed.includes(comm.id)) {
                            this.search.factory_cid.values.push(comm)
                        }
                    })
                })
            },
            remoteSearchMT(value) {
                if (!value.trim()) return;
                this.modal.searchLoading.mt = true;
                util.ajax.get('/device/searchoption', {
                    params: {
                        table: 't_depart',
                        field: 'name',
                        value: '%' + value.trim() + '%',
                        other: JSON.stringify({
                            type: 0,
                            role_id: roleTypes.MT_COMPANY
                        })
                    }
                }).then(res => {
                    this.modal.searchLoading.mt = false;
                    let existed = this.search.mt_cid.values.map(item => item.id)
                    res.data.forEach(comm => {
                        if (!existed.includes(comm.id)) {
                            this.search.mt_cid.values.push(comm)
                        }
                    })
                })
            },
            remoteSearchMTWorker(value) {
                if (!value) {
                    return new Promise((resolve, reject) => {
                        resolve()
                    });
                }
                let list = this.search.j_mt_woker.values;
                list.splice(0, list.length);
                if (!value) return;
                this.modal.searchLoading.mt_worker = true;
                return util.ajax.get('/user/listofcompany', {
                    params: {
                        companyId: value
                    }
                }).then(res => {
                    this.modal.searchLoading.mt_worker = false;
                    // res.data.forEach(worker => {
                    //     worker.name = worker.realname;
                    // })
                    // list.push(...res.data);
                })
            },
            remoteSearchAD(value) {
                if (!value.trim()) return;
                this.modal.searchLoading.ad = true;
                util.ajax.get('/device/searchoption', {
                    params: {
                        table: 't_depart',
                        field: 'name',
                        value: '%' + value + '%',
                        other: JSON.stringify({
                            type: 0,
                            role_id: roleTypes.AD
                        })
                    }
                }).then(res => {
                    this.modal.searchLoading.ad = false;
                    let existed = this.search.ad_cid.values.map(item => item.id)
                    res.data.forEach(comm => {
                        if (!existed.includes(comm.id)) {
                            this.search.ad_cid.values.push(comm)
                        }
                    })
                })
            },
            addAlarm(charger){
                this.search.j_alarm_charger.values.push(charger);
                this.modal.alarm_charger_mobile.push(charger.mobile);
            },
            addFzr(fzr){
                this.search.j_fzrs.values.push(fzr);
                this.modal.fzrs_mobile.push(fzr.mobile);
            },
            addMtWorker(mt){
                this.search.j_mt_woker.values.push(mt);
                this.modal.mt_worker_mbile.push(mt.mobile);
            },
            addAlarmCharger() {
                if(this.modal.alarm_charger_mobile.length>=2){
                    this.$Message.warning(this.$t("l.remark193"))
                    return;
                }
                let charger = {
                    name: '',
                    mobile: ''
                }
                this.$Modal.confirm({
                    render: (h) => {
                        return h('div', [
                            h('h3', this.$t('l.add_alarm_mobile')),
                            h('Form', {
                                    props: {
                                        'label-width': 80
                                    }
                                },
                                [
                                    h('FormItem', {
                                        props: {
                                            label: this.$t('l.name')
                                        }
                                    }, [h('Input', {
                                        props: {
                                            value: charger.name,
                                            placeholder: this.$t('l.remark39')
                                        },
                                        on: {
                                            input: (val) => {
                                                charger.name = val
                                            }
                                        }
                                    })]),
                                    h('FormItem', {
                                        props: {
                                            label:  this.$t('l.mobile')
                                        }
                                    }, [h('Input', {
                                        props: {
                                            value: charger.mobile,
                                            placeholder: this.$t('l.remark41')
                                        },
                                        on: {
                                            input: (val) => {
                                                charger.mobile = val
                                            }
                                        }
                                    })])
                                ])
                        ])
                    },
                    onOk: () => {
                        if (!charger.name || !charger.mobile) {
                            this.$Message.warning(this.$t('l.remark90'));
                            return;
                        }
                        if (!(/^1[3456789]\d{9}$/.test(charger.mobile))) {
                            this.$Message.warning(this.$t('l.remark91'));
                            return;
                        }
                        this.search.j_alarm_charger.values.push(charger);
                        this.modal.alarm_charger_mobile.push(charger.mobile);
                    }
                })
            },
            addFzrs(){
                let fzr = {
                    name: '',
                    mobile: ''
                }
                this.$Modal.confirm({
                    render: (h) => {
                        return h('div', [
                            h('h3', this.$t('l.add_principal')),
                            h('Form', {
                                    props: {
                                        'label-width': 80
                                    }
                                },
                                [
                                    h('FormItem', {
                                        props: {
                                            label: this.$t('l.name')
                                        }
                                    }, [h('Input', {
                                        props: {
                                            value: fzr.name,
                                            placeholder: this.$t('l.remark39')
                                        },
                                        on: {
                                            input: (val) => {
                                                fzr.name = val
                                            }
                                        }
                                    })]),
                                    h('FormItem', {
                                        props: {
                                            label: this.$t('l.mobile')
                                        }
                                    }, [h('Input', {
                                        props: {
                                            value: fzr.mobile,
                                            placeholder: this.$t('l.remark41')
                                        },
                                        on: {
                                            input: (val) => {
                                                fzr.mobile = val
                                            }
                                        }
                                    })])
                                ])
                        ])
                    },
                    onOk: () => {
                        if (!fzr.name || !fzr.mobile) {
                            this.$Message.warning( this.$t('l.remark90'));
                            return;
                        }
                        if (!(/^1[3456789]\d{9}$/.test(fzr.mobile))) {
                            this.$Message.warning(this.$t('l.remark91'));
                            return;
                        }
                        this.search.j_fzrs.values.push(fzr);
                        this.modal.fzrs_mobile.push(fzr.mobile);
                    }
                })
            },
            // 新建维保负责人
            addMtWorkers(){
                let mt = {
                    name: '',
                    mobile: ''
                }
                this.$Modal.confirm({
                    render: (h) => {
                        return h('div', [
                            h('h3', this.$t('l.add_maintenance')),
                            h('Form', {
                                    props: {
                                        'label-width': 80
                                    }
                                },
                                [
                                    h('FormItem', {
                                        props: {
                                            label: this.$t('l.name')
                                        }
                                    }, [h('Input', {
                                        props: {
                                            value: mt.name,
                                            placeholder: this.$t('l.remark39')
                                        },
                                        on: {
                                            input: (val) => {
                                                mt.name = val
                                            }
                                        }
                                    })]),
                                    h('FormItem', {
                                        props: {
                                            label: this.$t('l.mobile')
                                        }
                                    }, [h('Input', {
                                        props: {
                                            value: mt.mobile,
                                            placeholder: this.$t('l.remark41')
                                        },
                                        on: {
                                            input: (val) => {
                                                mt.mobile = val
                                            }
                                        }
                                    })])
                                ])
                        ])
                    },
                    onOk: () => {
                        if (!mt.name || !mt.mobile) {
                            this.$Message.warning(this.$t('l.remark90'));
                            return;
                        }
                        if (!(/^1[3456789]\d{9}$/.test(mt.mobile))) {
                            this.$Message.warning(this.$t('l.remark91'));
                            return;
                        }
                        this.search.j_mt_woker.values.push(mt);
                        this.modal.mt_worker_mbile.push(mt.mobile);
                    }
                })
            },
            onSubmit(name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        if (this.modal.device.device_param.is_through_door) { //
                            if (this.modal.totalFloor>32){
                                this.$Message.error(this.$t('l.hint43'))
                                return;
                            }
                        }
                        this.modal.loading = true;
                        let device = this.modal.device;
                        delete device.community_name;
                        delete device.caddress;
                        delete device.params_settings;
                        // delete device.terminal_type;
                        delete device.factory_name;
                        delete device.rolling_code_index;
                        delete device.broken;
                        delete device.card_status;
                        delete device.current_status;
                        delete device.j_region;
                        if (this.modal.alarm_charger_mobile.length) { // 告警人最多填写五位
                            if (this.modal.alarm_charger_mobile.length>=2){
                                this.$Message.error(this.$t('l.remark193'))
                                return;
                            }
                            device.j_alarm_charger = [];
                            this.modal.alarm_charger_mobile.forEach(mobile => {
                                let charger = this.chargerMap[mobile];
                                if (charger) {
                                    device.j_alarm_charger.push({
                                        mobile: charger.mobile,
                                        name: charger.name
                                    });
                                }else {
                                    device.j_alarm_charger=[]
                                }
                            })
                        }
                        else {
                            device.j_alarm_charger = null;
                        }
                        if (this.modal.fzrs_mobile.length) { // 负责人
                            device.j_fzrs = [];
                            this.modal.fzrs_mobile.forEach(mobile => {
                                let fzr = this.fzrMap[mobile];
                                if (fzr) {
                                    device.j_fzrs.push({
                                        mobile: fzr.mobile,
                                        name: fzr.name
                                    });
                                }
                            })
                        }
                        else {
                            device.j_fzrs = null;
                        }
                        if (this.modal.mt_worker_mbile.length) { // 维保人
                            device.j_mt_workers = [];
                            this.modal.mt_worker_mbile.forEach(mobile => {
                                let mt = this.mtWorkersMap[mobile];
                                if (mt) {
                                    device.j_mt_workers.push({
                                        mobile: mt.mobile,
                                        name: mt.name
                                    });
                                }
                            })
                        }
                        else {
                            device.j_mt_workers = null;
                        }
                        if (!device.terminal_id) device.terminal_id = null
                        if (!device.face_id) device.face_id = null
                        device.j_param = device.j_param ? device.j_param : {}
                        if (device.id) { // update
                            // if (!device.qr_id) { // 不存在qr_id
                            //     // if (this.currentDeviceIsHost) device.qr_id=1
                            //     // else device.qr_id = this.modal.confirmHostDeviceId
                            // }
                          delete device.aesIdCode;
                            util.ajax.put('/device/update', {
                                device: device,
                                // distantUpdate: this.modal.distantUpdate
                            }).then(res => {
                                this.modal.loading = false;
                                this.modal.show = false;
                                if (!res.code) {
                                    Object.keys(device).forEach(field => {
                                        this.table.data[this.modal.currentIndex][field] = device[field];
                                    })
                                    this.modal.currentIndex = -1;
                                    this.$Message.success(this.$t('l.edit_success'))
                                }
                            })
                        } else { //add
                            // device.qr_id = this.modal.currentDeviceIsHost?1:this.modal.confirmHostDeviceId
                            util.ajax.post('/device/add', device).then(res => {
                                this.modal.loading = false;
                                this.modal.show = false;
                                if (!res.code) {
                                    this.loadData(this.table.page.current, this.search);
                                    this.$Message.success(this.$t('l.add_success'))
                                }
                            }).catch(e => {
                                this.modal.loading = false;
                            })
                        }
                    } else {
                        this.$Message.error(this.$t('l.remark24'));
                    }
                })
            },
            onTotalFloorChange(value, upORdown) {
                this.modal.totalFloor = this.modal.device.j_floors.positive + this.modal.device.j_floors.negative;
                let originSize = this.modal.device.j_floors.display.length; // 修改之前的总楼层
                if (this.modal.device.device_param.is_through_door) {
                    // 根据修改之前的楼层显示，分组
                    let oriFloor = originSize / 2; // 修改之前 贯通门总楼层
                    let partA = this.modal.device.j_floors.display.slice(0, oriFloor);
                    let partB = this.modal.device.j_floors.display.slice(-oriFloor);

                    let partAdown = partA.slice(0, upORdown > 0 ? this.modal.device.j_floors.negative : (oriFloor - this.modal.device.j_floors.positive));
                    let partAup = partA.slice(upORdown > 0 ? this.modal.device.j_floors.negative : (oriFloor - this.modal.device.j_floors.positive));
                    let partBdown = partB.slice(0, upORdown > 0 ? this.modal.device.j_floors.negative : (oriFloor - this.modal.device.j_floors.positive));
                    let partBup = partB.slice(upORdown > 0 ? this.modal.device.j_floors.negative : (oriFloor - this.modal.device.j_floors.positive));

                    if (upORdown > 0) {
                        if (partAup.length < value) {
                            for (let i = partAup.length + 1; i <= value; i++) {
                                partAup.push(i.toString() + 'A');
                                partBup.push(i.toString() + 'B');
                            }
                        } else if (partAup.length > value) {
                            partAup.splice(value, partAup.length - value);
                            partBup.splice(value, partBup.length - value);
                        }
                    } else if (upORdown < 0) {
                        if (partAdown.length < value) {
                            for (let i = partAdown.length + 1; i <= value; i++) {
                                partAdown.unshift((-i).toString() + 'A');
                                partBdown.unshift((-i).toString() + 'B');
                            }
                        } else if (partAdown.length > value) {
                            partAdown.splice(0, partAdown.length - value);
                            partBdown.splice(0, partBdown.length - value);
                        }
                    }

                    this.modal.device.j_floors.display = partAdown.concat(partAup).concat(partBdown).concat(partBup)
                } else {
                    let partDOWN = this.modal.device.j_floors.display.slice(0, upORdown > 0 ? this.modal.device.j_floors.negative : (originSize - this.modal.device.j_floors.positive));
                    let partUP = this.modal.device.j_floors.display.slice(upORdown > 0 ? this.modal.device.j_floors.negative : (-(originSize - this.modal.device.j_floors.positive)));
                    if (upORdown > 0) {
                        if (partUP.length < value) {
                            for (let i = partUP.length + 1; i <= value; i++) {
                                this.modal.device.j_floors.display.push(i.toString());
                            }
                        } else if (partUP.length > value) {
                            this.modal.device.j_floors.display.splice(value + this.modal.device.j_floors.negative, partUP.length - value);
                        }
                    } else { // 修改负楼层
                        if (partDOWN.length < value) { // 新的负楼层多
                            for (let i = partDOWN.length + 1; i <= value; i++) {
                                this.modal.device.j_floors.display.unshift((-i).toString());
                            }
                        } else if (partDOWN.length > value) { // 新的负楼层少
                            this.modal.device.j_floors.display.splice(0, partDOWN.length - value);
                        }
                    }
                }
            },
            chooseRadio(v){
                // this.modal.device.regulatory_field={way:v};
                this.modal.filed_list = this.modal.push_way.find((e)=>{
                    return e.label === v;
                }).j_config;
            },
          loadOptions() {
            this.search.community_id.values = [];
            this.search.j_alarm_charger.values = [];
            this.search.j_fzrs.values = []
            this.search.j_mt_woker.values = [];
            this.search.factory_cid.values = [];
            this.search.factory_branch.values = [];
            this.search.mt_cid.values = [];
            this.search.ad_cid.values = [];

            // 2025年6月27日  拆分请求 一个请求有点慢  王欢

            util.ajax.get('/device/getVCompany').then(res => {
              if (res.data) {
                this.search.factory_cid.values = [];
                this.search.factory_branch.values = [];
                this.search.mt_cid.values = [];
                this.search.ad_cid.values = [];
                let myCompany = this.$store.state.user.user.company;
                if (!res.data.company.map(comp => comp.id).includes(myCompany.id)) {
                  res.data.company.push(myCompany);
                }
                res.data.company.map(company => {
                  switch (company.role_id) {
                    case roleTypes.AD:
                      this.search.ad_cid.values.push(company);
                      break;
                    case roleTypes.MT_COMPANY:
                      this.search.mt_cid.values.push(company);
                      break;
                    case roleTypes.ELEV_FACTORY:
                    case roleTypes.CONSUMER:
                      if (!company.pid) this.search.factory_cid.values.push(company);
                      else this.search.factory_branch.values.push(company);
                      break;
                  }
                })
              }
            })

            util.ajax.get('/device/getVCommunity').then(res => {
              if (res.data) {
                this.search.community_id.values = res.data.community;
              }

            })

            util.ajax.get('/device/getVAlarmAndFzrAndMt').then(res => {
              if (res.data) {
                this.search.j_alarm_charger.values = [];
                this.search.j_fzrs.values = []
                this.search.j_mt_woker.values = [];
                //所有告警人
                res.data.alarm_chargers.forEach(man => {
                  if (man && man.mobile) {
                    man.id = man.mobile;
                    if (!this.chargerMap[man.mobile]) this.search.j_alarm_charger.values.push(man);
                  }
                });
                //所有负责人
                if (res.data.fzrs) {
                  res.data.fzrs.forEach(mans => {
                    let manArr = JSON.parse(mans);
                    if (manArr && manArr.length) {
                      manArr.forEach(man => {
                        if (man && man.mobile) {
                          man.id = man.mobile;
                          if (!this.fzrMap[man.mobile]) this.search.j_fzrs.values.push(man);
                        }
                      });
                    }
                  });
                }
                // 所有维保人员
                res.data.j_mt_workers.forEach(mans => {
                  let manArr = JSON.parse(mans);
                  if (manArr && manArr.length) {
                    manArr.forEach(man => {
                      if (man && man.mobile) {
                        man.id = man.mobile;
                        if (!this.mtWorkersMap[man.mobile]) this.search.j_mt_woker.values.push(man);
                      }
                    });
                  }
                });

              }
            })

          },
            // loadOptions() {
            //     util.ajax.get('/device/getalloptions').then(res => {
            //         if (res.data) {
            //             this.search.community_id.values = res.data.community;
            //             this.search.j_alarm_charger.values = [];
            //             this.search.j_fzrs.values = []
            //             this.search.j_mt_woker.values = [];
            //             res.data.alarm_chargers.forEach(man => {
            //                         if (man && man.mobile) {
            //                             man.id = man.mobile;
            //                             if (!this.chargerMap[man.mobile]) this.search.j_alarm_charger.values.push(man);
            //                         }
            //             });
            //             //所有负责人
            //             if (res.data.fzrs){
            //                 res.data.fzrs.forEach(mans => {
            //                     let manArr = JSON.parse(mans);
            //                     if (manArr && manArr.length) {
            //                         manArr.forEach(man => {
            //                             if (man && man.mobile) {
            //                                 man.id = man.mobile;
            //                                 if (!this.fzrMap[man.mobile]) this.search.j_fzrs.values.push(man);
            //                             }
            //                         });
            //                     }
            //                 });
            //             }
            //             // 所有维保人员
            //             res.data.j_mt_workers.forEach(mans => {
            //                 let manArr = JSON.parse(mans);
            //                 if (manArr && manArr.length) {
            //                     manArr.forEach(man => {
            //                         if (man && man.mobile) {
            //                             man.id = man.mobile;
            //                             if (!this.mtWorkersMap[man.mobile]) this.search.j_mt_woker.values.push(man);
            //                         }
            //                     });
            //                 }
            //             });
            //             this.search.factory_cid.values = [];
            //             this.search.factory_branch.values = [];
            //             this.search.mt_cid.values = [];
            //             this.search.ad_cid.values = [];
            //             let myCompany = this.$store.state.user.user.company;
            //             if (!res.data.company.map(comp => comp.id).includes(myCompany.id)) {
            //                 res.data.company.push(myCompany);
            //             }
            //             res.data.company.map(company => {
            //                 switch (company.role_id) {
            //                     case roleTypes.AD:
            //                         this.search.ad_cid.values.push(company);
            //                         break;
            //                     case roleTypes.MT_COMPANY:
            //                         this.search.mt_cid.values.push(company);
            //                         break;
            //                     case roleTypes.ELEV_FACTORY:
            //                     case roleTypes.CONSUMER:
            //                         if (!company.pid) this.search.factory_cid.values.push(company);
            //                         else this.search.factory_branch.values.push(company);
            //                         break;
            //                 }
            //             })
            //         }
            //     })
            // },
        },
        created(){
            util.getAuth();
            this.loadOptions();
            this.$store.commit("setMobile",true);
            ws.init();
        },
        computed:{
            getRules(){
                return   {
                    'device.name':[{required: true, message: this.$t('l.remark33'), trigger: 'blur'}],
                    totalFloor:[{validator: this.validateTotalFloor, trigger: 'blur'}],
                }
            },
            getDeviceTypeList(){
                return  [
                    {id: 0, lable: this.$t('l.lift_type1')},
                    {id: 1, lable: this.$t('l.lift_type2')},
                    {id: 2, lable: this.$t('l.lift_type3')},
                    {id: 3, lable: this.$t('l.lift_type4')},
                ]
            },
            chargerMap() {
                let map = {};
                this.search.j_alarm_charger.values.forEach(charger => {
                    map[charger.mobile] = charger;
                })
                return map;
            },
            fzrMap(){
                let map = {};
                this.search.j_fzrs.values.forEach(fzr => {
                    map[fzr.mobile] = fzr;
                })
                return map;
            },
            mtWorkersMap(){
                let map = {};
                this.search.j_mt_woker.values.forEach(mt => {
                    map[mt.mobile] = mt;
                })
                return map;
            },
            deviceMap() {
                let map = {};
                this.table.data.forEach(device => {
                    if (device.terminal_id) {
                        map[device.terminal_id] = device;
                    } else {
                        if (device.vm_device_id) map[device.vm_device_id] = device;
                    }
                })
                return map;
            },
        },
        mounted(){
            this.height = this.$refs.deviceList.clientHeight;
            this.loadLikes();
            this.loadData();
            this.loadIndexData();
        }
    }
</script>

<style scoped lang="less">
    .home-header{
        height: 8%;
        display: flex;
        align-items: center;
        background: #4671e4;
        padding-right: 10px;
        color: #fff;
        .main-header-left-logo{
            min-width: 200px;
            height: 40px;
            border-radius: 4px;
            background-size: auto 100%;
            cursor: pointer;
            display: block;
            background-image: url("../../../public/images/qrcode/diantiyun.png");
        }
    }
    .device-count{
        display: flex;
        height: 20%;
        flex-wrap: wrap;
        width: 100%;
        .item{
            width: calc((100% - 30px)/2);
            margin-top: 10px;
            margin-left: 10px;
            color: #fff;
            font-weight: 600;
            font-size: 14px;
            border-radius:4px ;
            height: calc(50% - 10px);
            text-align: center;
            display: grid;
            align-items: center;
            &-title{
                display: block;
                vertical-align: center;
            }
        }
        .all-device{
            background-image:linear-gradient(#0984e3, #74b9ff) ;
            box-shadow: 4px 4px 4px #ced6e0;
        }
        .fault-device{
            background-image:linear-gradient(#e17055, #ff7675) ;
            box-shadow: 4px 4px 4px #ced6e0;
        }
        .offline-device{
            background-image:linear-gradient(#b2bec3, #dfe6e9) ;
            box-shadow: 4px 4px 4px #ced6e0;
        }
        .online-device{
            background-image:linear-gradient(#00b894, #55efc4) ;
            box-shadow: 4px 4px 4px #ced6e0;
        }
    }
    .search-add{
        height: calc(5% - 10px);
        width: calc(100% - 20px);
        margin-top: 10px;
        display: flex;
        justify-content: flex-end;
        margin-left: 10px;
    }
    .device-list{
        height: calc(69% - 20px);
        max-height: calc(69% - 20px);
        margin-top: 5px;
        overflow-y: auto;
        position: relative;
        .device-item{
            height: 100px;
            width: calc(100% - 20px);
            /*margin-top: 10px;*/
            border-radius: 4px;
            background-color: #f1f2f6;
            -webkit-box-shadow: 4px 4px 8px #ced6e0;
            box-shadow: 4px 4px 8px #ced6e0;
            padding: 5px 10px;
            display: flex;
            align-items: center;
            margin-left: 10px;
            position: relative;
            .device-type-icon{
                    display: block;
                    width: 20%;
            }
            .device-other{
                width: 80%;
                height: 100%;
                .device-name{
                    display: flex;
                    height: 80%;
                    max-width: 85%;
                    align-items: center;
                    font-size: 14px;
                    overflow-x: hidden;
                    margin-left: 10px;
                }
                .device-preedit{
                    position: absolute;
                    top: 10px;
                    right: 10px;
                    color: #0984e3;
                    /*z-index: 9999 !important;*/
                    /*font-size: 14px;*/
                    /*width: 32px;*/
                }
                .terminal_type{
                    font-weight: 700;
                    font-size: 12px;
                    padding: 0 2px;
                    border: 1px solid #000;
                    border-radius: 4px;
                    display: inline-block;
                    margin-right: 10px;
                }
                .device-status{
                    display: block;
                }
                .device-dian{
                    display: block;
                    width: 10px;
                    height: 10px;
                    border-radius: 50%;
                }
                .device-status-online{
                    display: flex;
                    align-items: center;
                    width: 100%;
                    justify-content: flex-end;
                    .floor-direction{
                        font-size: 16px;
                    }
                    .floor-text{
                        font-size: 14px;
                    }
                    .device-status-dian{
                        width: 10px;
                        height: 10px;
                        border-radius: 50%;
                        background-image: linear-gradient(to top, #bdc3c7 ,#ecf0f1);
                    }
                    .device-status-dian-fault{
                        width: 10px;
                        height: 10px;
                        border-radius: 50%;
                        background-image: linear-gradient(#e17055, #ff7675);
                    }
                    .device-status-dian-online{
                        width: 10px;
                        height: 10px;
                        border-radius: 50%;
                        background-image: linear-gradient(to top, #27ae60 ,#2ecc71);
                    }
                    .device-status-text-online{
                        color: #2ecc71;
                    }
                    .device-status-text-fault{
                        color: #ff7675;
                    }
                }
            }
        }
        .no-data-image{
            width: 100%;
            height: 200px;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-image: url("../../../public/images/mobile/wushuju.svg");
        }
        .no-data-text{
            width: 100%;
            font-size: 20px;
            font-weight: 600;
            color: #8a8a8a;
            text-align: center;
        }
    }
</style>